__turbopack_context__.v({
  "h2": "[uri]-module-scss-module__7yaG0G__h2",
});
